"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FooterLink = _interopRequireDefault(require("./FooterLink"));

var _excluded = ["footerLinks", "footerNavAriaLabel"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultFooterServiceLinks = [{
  linkText: 'About Regions',
  hrefPath: 'https://www.regions.com/about-regions',
  dataTestId: 'about-regions-link'
}, {
  linkText: 'Investor Relations',
  hrefPath: 'https://ir.regions.com/',
  dataTestId: 'inv-rel-link'
}, {
  linkText: 'Privacy & Security',
  hrefPath: 'https://www.regions.com/about-regions/privacy-security',
  dataTestId: 'priv-sec-link'
}, {
  linkText: 'Website Terms of Use',
  hrefPath: 'https://www.regions.com/about-regions/privacy-security/terms-conditions',
  dataTestId: 'terms-link'
}, {
  linkText: 'Online Tracking & Advertising',
  hrefPath: 'https://www.regions.com/about-regions/privacy-security/online-privacy-notice#ads',
  dataTestId: 'tracking-link'
}, {
  linkText: 'Accessible Banking',
  hrefPath: 'https://www.regions.com/about-regions/accessible-banking',
  dataTestId: 'accessible-banking-link'
}, {
  linkText: 'Leave Feedback',
  hrefPath: 'https://survey.regions.com/jfe/form/SV_0Jm6o1kcV7mAmA5?source=rdodeposit',
  dataTestId: 'feedback-link',
  target: '_blank'
}];
var FooterServiceLinks = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var footerLinks = _ref.footerLinks,
      footerNavAriaLabel = _ref.footerNavAriaLabel,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("nav", _extends({
    className: "footer__nav",
    role: "navigation",
    "aria-label": footerNavAriaLabel,
    ref: ref
  }, additionalProps), /*#__PURE__*/_react.default.createElement("ul", {
    className: "footer__nav-list",
    role: "list"
  }, footerLinks.map(function (link) {
    return /*#__PURE__*/_react.default.createElement(_FooterLink.default, {
      key: link.hrefPath,
      linkText: link.linkText,
      hrefPath: link.hrefPath,
      dataTestId: link.dataTestId,
      target: link.target
    });
  })));
});
FooterServiceLinks.displayName = 'FooterServiceLinks';
FooterServiceLinks.propTypes = {
  footerLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    linkText: _propTypes.default.string.isRequired,
    hrefPath: _propTypes.default.string.isRequired,
    dataTestId: _propTypes.default.string
  })),
  footerNavAriaLabel: _propTypes.default.string
};
FooterServiceLinks.defaultProps = {
  footerLinks: defaultFooterServiceLinks,
  footerNavAriaLabel: 'footer navigation'
};
var _default = FooterServiceLinks;
exports.default = _default;